module.exports = __webpack_public_path__ + "media/images/layouts/classroom-7165fec3819cdb9e6f7cf0d013bceb70.png";